module.exports = __webpack_public_path__ + "assets/img/banner.bad21c40.png";